import { Link } from 'react-router-dom';

export default function Footer() {
  const quickLinks = [
    { name: 'Hjem', href: '/' },
    { name: 'Tjenester', href: '/tjenester' },
    { name: 'Om oss', href: '/om-oss' },
    { name: 'Nyhetsbrev', href: '/nyhetsbrev' },
    { name: 'Kontakt', href: '/kontakt' }
  ];

  const services = [
    'Bokføring',
    'Regnskap',
    'Lønn',
    'MVA-rapportering',
    'Årsregnskap',
    'Stiftelse av selskap'
  ];

  const handlePhoneClick = () => {
    window.location.href = 'tel:+4795487639';
  };

  const handleEmailClick = () => {
    window.location.href = 'mailto:post@easya.no';
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-8 sm:py-12 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {/* Company Info */}
          <div className="col-span-1 sm:col-span-2">
            <div className="mb-3 sm:mb-4">
              <img 
                src="https://static.readdy.ai/image/6ed595d4427e0cbb8261bffe6047b408/ca4d10f6f2a4b03e54df831eeeeb8f26.png" 
                alt="Easy Accounting AS" 
                className="h-12 sm:h-16 w-auto filter brightness-0 invert"
              />
            </div>
            <p className="text-gray-300 mb-3 sm:mb-4 max-w-md text-sm sm:text-base">
              Din pålitelige partner for regnskaps- og bokføringstjenester. Vi hjelper bedrifter med å holde orden på økonomien.
            </p>
            <div className="flex space-x-3 sm:space-x-4">
              <div 
                className="w-8 sm:w-10 h-8 sm:h-10 flex items-center justify-center bg-blue-600 rounded-full cursor-pointer hover:bg-blue-700 transition-colors"
                onClick={handlePhoneClick}
                title="Ring oss: +47 954 87 639"
              >
                <i className="ri-phone-line text-sm sm:text-lg"></i>
              </div>
              <div 
                className="w-8 sm:w-10 h-8 sm:h-10 flex items-center justify-center bg-blue-600 rounded-full cursor-pointer hover:bg-blue-700 transition-colors"
                onClick={handleEmailClick}
                title="Send e-post: post@easya.no"
              >
                <i className="ri-mail-line text-sm sm:text-lg"></i>
              </div>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Hurtiglenker</h3>
            <ul className="space-y-1 sm:space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.href} 
                    className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm sm:text-base"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Services */}
          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Tjenester</h3>
            <ul className="space-y-1 sm:space-y-2">
              {services.map((service) => (
                <li key={service}>
                  <span className="text-gray-300 text-sm sm:text-base">{service}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        
        <div className="mt-6 sm:mt-8 pt-6 sm:pt-8 border-t border-gray-800 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400 text-xs sm:text-sm">
            © 2025 Easy Accounting AS. Alle rettigheter reservert.
          </p>
        </div>
      </div>
    </footer>
  );
}
